import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ChecklistTasksTemplates.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { WidgetVisibility } from '../../utils/widgetManager';
import { Link } from 'react-router-dom';

const ChecklistTasksTemplatesTable = ({ tableData = [], userProfileWidgets = {}, viewName }) => {
  return (
    <Table variant className={s.wsInnerTable}>
      <thead>
        <tr>
          <th>
            <FormattedMessage id="common.name" defaultMessage="Name" />
          </th>
          <th>
            {viewName === 'TASKTEMPLATEVIEW' ? (
              <FormattedMessage id="taskTemplateManagement.serviceTask" defaultMessage="Service task" />
            ) : (
              <FormattedMessage id="checklistTemplateManagement.isService" defaultMessage="Service checklist" />
            )}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {tableData.map(n => {
          return (
            <Fragment key={`${viewName}-${n.Id}`}>
              <tr key={`${viewName}-${n.Id}`} data-unittest="templateData">
                <td>{n.Name}</td>
                <td>{viewName === 'TASKTEMPLATEVIEW' ? (n.IsServiceTask ? 'Yes' : 'No') : n.IsServiceChecklist ? 'Yes' : 'No'}</td>
                <td className={`${s.btnCol} ${s.buttonContainer}`}>
                  <Link to={n.Link}>
                    <Button
                      variant="outline-secondary"
                      data-unittest="view"
                      className={s.viewButton}
                      style={WidgetVisibility(userProfileWidgets, viewName)}
                    >
                      <FormattedMessage id="checklistTasksTemplates.view" defaultMessage="VIEW" />
                    </Button>
                  </Link>
                </td>
              </tr>
            </Fragment>
          );
        })}
      </tbody>
    </Table>
  );
};



ChecklistTasksTemplatesTable.propTypes = {
  tableData: PropTypes.array.isRequired,
  userProfileWidgets: PropTypes.object.isRequired,
  viewName: PropTypes.string.isRequired
};

export default injectIntl(ChecklistTasksTemplatesTable);
